import { type ExpenseTagColorEnum } from "@finway-group/shared/lib/models"
import React from "react"
import { useDispatch } from "react-redux"
import { TagSection } from "~Components/TagSection"
import { attachTagExpense, detachTagExpense } from "~Shared/store/actions/expense/expenseActions"
import { createExpenseTag, deleteExpenseTag } from "~Shared/store/actions/expenseTag/expenseTagActions"

interface ExpenseTagSectionProps {
    expenseId: string
    expenseTags: Array<string>
    onTagChange?: (tagId: string, detach: boolean) => void
    hideButton?: boolean
    hideTags?: boolean
    inCreation?: boolean
}

const MAX_TAGS = 3

export const ExpenseTagSection = ({ expenseId, expenseTags, onTagChange, hideButton = false, hideTags = false, inCreation = false }: ExpenseTagSectionProps) => {
    const dispatch = useDispatch()

    const handleTagCreate = async (tagColor: ExpenseTagColorEnum, tagName: string) => {
        if (!inCreation) {
            await dispatch(createExpenseTag({ tagName, tagColor }, expenseId))
        } else {
            await dispatch(
                createExpenseTag({ tagName, tagColor }, undefined, (id: string) => {
                    if (onTagChange) {
                        onTagChange(id, false)
                    }
                }),
            )
        }
    }

    const handleTagDelete = async (expenseTagId: string) => {
        await dispatch(deleteExpenseTag(expenseTagId))
        if (onTagChange) {
            onTagChange(expenseTagId, true)
        }
    }

    const handleTagSelected = async (expenseTagId: string) => {
        if (!inCreation) {
            await dispatch(attachTagExpense(expenseTagId, expenseId))
        }
        if (onTagChange) {
            onTagChange(expenseTagId, false)
        }
    }

    const handleTagDetach = async (expenseTagId: string) => {
        if (!inCreation) {
            await dispatch(detachTagExpense(expenseTagId, expenseId))
        } else if (onTagChange) {
            onTagChange(expenseTagId, true)
        }
    }

    return (
        <TagSection
            entityTags={expenseTags}
            hideButton={hideButton}
            hideTags={hideTags}
            maxTags={MAX_TAGS}
            tagClassName="m-5 h-34"
            onTagCreate={handleTagCreate}
            onTagDelete={handleTagDelete}
            onTagSelected={handleTagSelected}
            onTagDetach={handleTagDetach}
        />
    )
}
